import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { memo } from "react";

// TODO(karlbernard): [NX-11136] Replace with CMS keys (subscription:page.landing.privacy*) once registered.
const EYEBROW = "Discreet & secure";
const TITLE = "What happens here, stays here";

type PrivacyItem = {
  readonly icon: string;
  readonly title: string;
  readonly body: string;
};

type PrivacySectionProps = {
  readonly items: readonly PrivacyItem[];
};

function PrivacySection({ items }: PrivacySectionProps) {
  return (
    <section className="pb-2 pt-7 md:pt-12 md:text-center" data-testid="PrivacySection">
      <Text className="block tracking-[0.16em] uppercase text-blue-600 dark:text-blue-400 mb-2">{EYEBROW}</Text>
      <Text
        variant={TextVariants.HEADING_4_BOLD}
        className="block md:text-[30px] tracking-tight text-gray-900 dark:text-white mb-[18px] md:mb-7 text-balance"
      >
        {TITLE}
      </Text>

      <div className="flex flex-col gap-2.5 md:flex-row md:gap-4">
        {items.map((privacyItem) => (
          <div
            key={privacyItem.title}
            className="flex flex-1 items-start gap-3.5 rounded-2xl border border-gray-100 bg-gray-50 dark:border-white/[0.06] dark:bg-[#101014] p-4 md:flex-col md:text-left"
            data-testid={`PrivacySection-${privacyItem.title.replace(/\s+/g, "")}`}
          >
            <span className="grid h-[38px] w-[38px] shrink-0 place-items-center rounded-[10px] bg-blue-500/15 text-lg">{privacyItem.icon}</span>
            <div>
              <Text variant={TextVariants.LABEL_LARGE_BOLD} className="block leading-snug text-gray-900 dark:text-white mb-[3px]">
                {privacyItem.title}
              </Text>
              <Text variant={TextVariants.PARAGRAPH_SMALL_REGULAR} className="block text-gray-600 dark:text-white/60 leading-relaxed">
                {privacyItem.body}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default memo(PrivacySection);
